import { Box, LinearProgress } from "@mui/material";
import { useState } from "react";
import { QAndA } from "./QAndA";

const questions = [
  { text: "創作を考え、それを表現するのが好き", courses: ["design"] },
  { text: "流行りのものを学ぶことが好き", courses: ["frontend"] },
  { text: "見た目より物事の仕組みを知りたい", courses: ["backend"] },
  { text: "論理的に課題解決をしたい", courses: ["data"] },
  { text: "理論より感覚だ", courses: ["design"] },
  { text: "人と協力して学びあうのが好き", courses: ["data"] },
  { text: "1人でサービスのリリースまでやってみたい", courses: ["mobile"] },
  {
    text: "目に見えて作っていくのが好き",
    courses: ["design", "frontend", "mobile"],
  },
  {
    text: "プログラミングを用いて何か作りたい",
    courses: ["frontend", "backend", "mobile"],
  },
  { text: "データを扱ってみたい", courses: ["backend", "data"] },
];

export const Questions = ({ setPage }) => {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [isFinished, setIsFinished] = useState(false);

  //次の問題へ進む。もし最後の問題であれば、QAndAコンポーネントに終了であることを伝え、4秒後にresult画面に遷移する
  const goNext = () => {
    setQuestionIndex((questionIndex) => questionIndex + 1);
    if (questionIndex + 1 === questions.length) {
      setIsFinished(true);
      //isFinishedがtrueになるとQAndAコンポーネントが終了！という文字を表示するので、それを表示するための時間として4000msを設定しています。
      setTimeout(() => {
        setPage("result");
      }, 4000);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          padding: "8px 0",
          marginBottom: "40px",
        }}
      >
        <LinearProgress
          variant="determinate"
          value={(questionIndex / questions.length) * 100}
        />
      </Box>
      <QAndA
        questionIndex={questionIndex}
        question={questions[questionIndex]}
        isFinished={isFinished}
        goNext={goNext}
      />
    </Box>
  );
};
